import React from 'react';
import { useTranslation } from 'react-i18next';
import clsx from 'clsx';
import Box from '@material-ui/core/Box';
import Divider from '@material-ui/core/Divider';
import Grid from '@material-ui/core/Grid';
import { makeStyles, Theme } from '@material-ui/core/styles';
import Logo from '../../../assets/LWT_Logo.svg';

const useStyles = makeStyles((theme: Theme) => {
  return {
    footerContainer: {
      bottom: 0,
      zIndex: theme.zIndex.drawer
    },
    footer: {
      background: '#2e2e2e',
      paddingTop: theme.spacing(0.25),
      paddingRight: theme.spacing(27),
      paddingBottom: theme.spacing(0.25),
      paddingLeft: theme.spacing(5),
      [theme.breakpoints.down('md')]: {
        paddingTop: theme.spacing(0.5),
        paddingRight: 0,
        paddingBottom: theme.spacing(0.5),
        paddingLeft: 0
      }
    },
    logo: {
      display: 'block',
      height: 50,
      width: 260,
      [theme.breakpoints.down('md')]: {
        margin: 'auto',
        height: 40
      }
    },
    textContainer: {
      alignContent: 'center',
      justifyContent: 'flex-end',
      [theme.breakpoints.down('md')]: {
        marginTop: theme.spacing(1),
        justifyContent: 'center'
      }
    },
    text: {
      ...theme.typography.body1,
      color: 'white',
      textDecoration: 'none',
      fontSize: theme.typography.subtitle2.fontSize
    },
    link: {
      '&:hover': {
        textDecoration: 'underline'
      }
    },
    divider: { backgroundColor: 'white' }
  };
});

const Footer = (): React.ReactElement => {
  const classes = useStyles();
  const { t } = useTranslation('Footer');

  return (
    <Box component="footer" displayPrint="none" className={classes.footerContainer}>
      <Grid container className={classes.footer}>
        <Grid item xs={12} lg>
          <img src={Logo} alt={t('Keyboarding Without Tears Logo')} className={classes.logo} />
        </Grid>
        <Grid container item xs={12} lg alignItems="center" className={classes.textContainer}>
          <Grid item>
            <a
              href="https://www.lwtears.com/privacy-policy"
              target="_blank"
              rel="noopener noreferrer"
              className={clsx(classes.text, classes.link)}
            >
              {t('Privacy Policy')}
            </a>
          </Grid>
          <Divider flexItem orientation="vertical" variant="middle" className={classes.divider} />
          <Grid item>
            <a
              href="https://www.lwtears.com/terms-conditions"
              target="_blank"
              rel="noopener noreferrer"
              className={clsx(classes.text, classes.link)}
            >
              {t('Terms of Service')}
            </a>
          </Grid>
          <Divider flexItem orientation="vertical" variant="middle" className={classes.divider} />
          <Grid item>
            <span className={classes.text}>{t('Copyright © 2023')}</span>
          </Grid>
        </Grid>
      </Grid>
    </Box>
  );
};

export default Footer;
